var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14C9 12.8954 9.89543 12 11 12C12.1046 12 13 12.8954 13 14C13 15.1046 12.1046 16 11 16C9.89543 16 9 15.1046 9 14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 14C3 12.8954 3.89543 12 5 12C6.10457 12 7 12.8954 7 14C7 15.1046 6.10457 16 5 16C3.89543 16 3 15.1046 3 14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 21C9 19.8954 9.89543 19 11 19C12.1046 19 13 19.8954 13 21C13 22.1046 12.1046 23 11 23C9.89543 23 9 22.1046 9 21Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 21C3 19.8954 3.89543 19 5 19C6.10457 19 7 19.8954 7 21C7 22.1046 6.10457 23 5 23C3.89543 23 3 22.1046 3 21Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 7C9 5.89543 9.89543 5 11 5C12.1046 5 13 5.89543 13 7C13 8.10457 12.1046 9 11 9C9.89543 9 9 8.10457 9 7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7C3 5.89543 3.89543 5 5 5C6.10457 5 7 5.89543 7 7C7 8.10457 6.10457 9 5 9C3.89543 9 3 8.10457 3 7Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnd);
export default __webpack_public_path__ + "static/media/dnd.26b7189a711f880da0b057ecacebd17f.svg";
export { ForwardRef as ReactComponent };